// export const roomsData = [
//   {
//     id: 1,
//     name: "Deluxe Room",
//     image: "https://images.unsplash.com/photo-1611892440504-42a792e24d32?auto=format&fit=crop&w=900&q=80",
//     price: "₹2,499",
//     capacity: "2 Guests",
//     size: "220 sq.ft",
//     bed: "1 Queen Bed",
//     short: "A calm, air-conditioned retreat with modern comforts and refreshing garden views.",
//     features: ["Air Conditioned", "LED TV", "Free Wi-Fi", "24×7 Hot Water", "Room Service", "Garden View"],
//   },
//   {
//     id: 2,
//     name: "Super Deluxe Room",
//     image: "https://images.unsplash.com/photo-1590490360182-c33d57733427?auto=format&fit=crop&w=900&q=80",
//     price: "₹3,499",
//     capacity: "3 Guests",
//     size: "280 sq.ft",
//     bed: "1 King Bed",
//     short: "Spacious comfort with premium furnishings — ideal for couples who want a little extra.",
//     features: ["Air Conditioned", "LED TV", "Free Wi-Fi", "Mini Fridge", "Tea / Coffee Maker", "Balcony Sitting"],
//   },
//   {
//     id: 3,
//     name: "Executive Suite",
//     image: "https://images.unsplash.com/photo-1595576508898-0ad5c879a061?auto=format&fit=crop&w=900&q=80",
//     price: "₹4,999",
//     capacity: "3 Guests",
//     size: "380 sq.ft",
//     bed: "King Bed + Lounge",
//     short: "A private living area, elegant décor and pool views for a truly royal stay.",
//     features: ["Separate Living Area", "Air Conditioned", "LED TV", "Free Wi-Fi", "Mini Fridge", "Pool View"],
//   },
//   {
//     id: 4,
//     name: "Family Room",
//     image: "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?auto=format&fit=crop&w=900&q=80",
//     price: "₹5,499",
//     capacity: "4–5 Guests",
//     size: "420 sq.ft",
//     bed: "2 Queen Beds",
//     short: "Roomy, comfortable and thoughtfully designed for memorable family getaways.",
//     features: ["Air Conditioned", "2 Queen Beds", "LED TV", "Free Wi-Fi", "Extra Bed Available", "Garden View"],
//   },
// ];


export const roomsData = [
  // {
  //   id: 1,
  //   name: "Deluxe Room",
  //   image: "/images/Rooms/Room-1.jpeg",       // 👈 local
  //   price: "₹2,499",
  //   capacity: "2 Guests",
  //   size: "220 sq.ft",
  //   bed: "1 Queen Bed",
  //   short: "A calm, air-conditioned retreat with modern comforts and refreshing garden views.",
  //   features: ["Air Conditioned", "LED TV", "Free Wi-Fi", "24×7 Hot Water", "Room Service", "Garden View"],
  // },
  // {
  //   id: 2,
  //   name: "Super Deluxe Room",
  //   image: "/images/Rooms/Room-2.jpeg",       // 👈 local
  //   price: "₹3,499",
  //   capacity: "3 Guests",
  //   size: "280 sq.ft",
  //   bed: "1 King Bed",
  //   short: "Spacious comfort with premium furnishings — ideal for couples who want a little extra.",
  //   features: ["Air Conditioned", "LED TV", "Free Wi-Fi", "Mini Fridge", "Tea / Coffee Maker", "Balcony Sitting"],
  // },
  {
    id: 3,
    name: "Executive Suite",
    image: "/images/Rooms/Room-3.jpeg",       // 👈 local
    price: "₹4,999",
    capacity: "5+ Guests",
    size: "380 sq.ft",
    bed: "King Bed + Lounge",
    short: "A private living area, elegant décor and lawn views for a truly royal stay.",
    features: ["Premium Living Area", "Air Conditioned", "LED TV", "Free Wi-Fi", "Warm ambient lighting", "Premium upholstered furniture", "Lawn View"],
  },
];